<template>
  <div id="selfAssessIndex">
    <div class="fitPc">
      <h3>评审管理</h3>
      <div class="tabs">
        <div class="tabsItem" @click="handleTabs(item)" :class="{ activr: item.id == parame.status }" v-for="(item, index) in tabs.data" :key="`${index}a`">
          {{ item.name }}
        </div>
        <el-input size="small" style="width: 40%; margin-left: auto" placeholder="请输入你需要搜索的内容" v-model="parame.keyWords" clearable> </el-input>
      </div>
      <!-- 列表 -->
      <div class="table" v-loading="loading" element-loading-text="拼命加载中">
        <el-table stripe :data="tableData" ref="table">
          <!-- 截止时间 -->
          <el-table-column min-width="125px" label="截止时间" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.startTime"> {{ moment(scope.row.endTime).format('YYYY.M.D') }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column min-width="125px" label="发起者" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.creatorNmae"> {{ scope.row.creatorNmae }}</span>
            </template>
          </el-table-column>
          <!-- 评审流程状态	-->
          <el-table-column min-width="120px" label="评审流程状态" align="center">
            <template slot-scope="scope">
              <span :class="['orange', 'orange', 'theme', 'red', 'green'][scope.row.status - 1]">
                {{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][scope.row.status - 1] }}
              </span>
            </template>
          </el-table-column>
          <!-- 评审类型 -->
          <el-table-column min-width="90px" label="评审类型" align="center">
            <template slot-scope="scope">
              {{ ['日常评审', '年度评审'][scope.row.type - 1] }}
            </template>
          </el-table-column>
          <!-- 评审专家 -->
          <el-table-column min-width="120px" show-overflow-tooltip label="评审专家" align="center">
            <template slot-scope="scope"> {{ scope.row.expertName || '--' }}</template>
          </el-table-column>
          <!-- 自评得分 -->
          <el-table-column min-width="90px" label="自评得分" align="center">
            <template slot-scope="scope"> {{ scope.row.selfScore || '--' }}</template>
          </el-table-column>
          <!-- 设备管理成熟度 -->
          <el-table-column min-width="130px" label="设备管理成熟度" align="center">
            <template slot-scope="scope"> {{ scope.row.evaluate || '--' }}% </template>
          </el-table-column>
          <!-- 评审得分 -->
          <el-table-column min-width="90px" label="评审得分" align="center">
            <template slot-scope="scope"> {{ scope.row.appraisalResult || '--' }}</template>
          </el-table-column>
          <!-- 星级 -->
          <el-table-column min-width="90px" label="星级" align="center">
            <template slot-scope="scope"> {{ scope.row.starLevel || '--' }}</template>
          </el-table-column>
          <el-table-column min-width="190px" label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <!--  {{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][scope.row.status - 1] }} -->
              <el-button v-if="scope.row.status == 1" type="text" @click.stop="rowClick(scope.row)">前往自评</el-button>
              <el-button v-if="scope.row.status == 2" type="text" @click.stop="rowClick(scope.row)">编辑</el-button>
              <el-button v-if="scope.row.status == 5" type="text" @click.stop="rowClick(scope.row)">查看评审报告</el-button>
              <el-button v-if="scope.row.status == 5" type="text" @click.stop="rowClick(scope.row)">查看证书</el-button>
              <el-button v-if="scope.row.status != 1" type="text" @click.stop="rowClick(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <div slot="empty">
            <img src="../../assets/img/emptyData.png" alt="" />
          </div>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <div>共{{ total }}条数据</div>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="parame.page"
          :page-size="parame.limit"
          :pager-count="5"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 手机端 -->
    <div class="fitIpone">
      <h3 style="display: flex">
        评审管理
        <el-input
          @change="getQuestionList"
          @keyup.enter.native="getQuestionList"
          size="small"
          style="width: 50%; margin-left: auto"
          placeholder="请输入你需要搜索的内容"
          v-model="parame.keyWords"
          clearable>
        </el-input>
      </h3>
      <div class="tabs">
        <div class="tabsItem" @click="handleTabs(item)" :class="{ activr: item.id == parame.status }" v-for="(item, index) in tabs.data" :key="`${index}a`">
          {{ item.name }}
        </div>
      </div>
      <div class="listIpone" v-loading="loading" element-loading-text="拼命加载中">
        <template v-if="tableData && tableData.length">
          <div class="listIBox" @click.stop="rowClick(item)" v-for="(item, index) in tableData" :key="`${index}c`">
            <div class="listIponeItem">
              <div class="left">
                <div class="tiles">
                  <span class="tiltBox" :class="['tileOrruge', 'tileOrruge', 'tileBlue', 'tileRed', 'tileGreen'][item.status - 1]"></span>
                  评审-{{ item.recordNumber }}
                </div>
                <div class="time">
                  截止时间:<span v-if="item.endTime"> {{ moment(item.endTime).format('YYYY.MM.DD HH:mm:ss') }}</span>
                  <span v-else>暂无</span>
                </div>
                <div class="time" v-if="item.creatorNmae">
                  发起者:<span>{{ item.creatorNmae || '--' }}</span>
                </div>
                <div class="time" v-if="item.expertName">
                  评审专家:<span>{{ item.expertName || '--' }}</span>
                </div>
                <div class="box" :class="['DayBox', 'YearBox'][item.type - 1]">{{ ['日常评审', '年度评审'][item.type - 1] }}</div>
              </div>
              <div class="right">
                <el-button type="text" :class="['orange', 'orange', 'blue', 'red', 'green'][item.status - 1]">{{
                  ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][item.status - 1]
                }}</el-button>
              </div>
            </div>
            <div v-if="item.status == 5">
              <div class="rowList">自评得分：</div>
              <div class="rowList">
                评审得分：{{ item.selfScore }}
                <span class="line"></span>
                设备管理成熟度：{{ item.evaluate }}
                <span class="line"></span>
                星级：{{ item.starLevel }}
              </div>
            </div>
          </div>
        </template>
        <div v-else style="text-align: center">
          <img src="../../assets/img/emptyData.png" alt="" />
        </div>
        <!-- 分页 -->
        <div class="pagination" style="justify-content: flex-end">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="parame.page"
            :page-size="parame.limit"
            :pager-count="5"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'selfAssessIndex',
  components: {},
  data() {
    return {
      loading: true,
      tabs: {
        data: [
          { name: '全部', id: '' },
          { name: '待自评', id: 1 },
          { name: '待分配', id: 2 },
          { name: '评审中', id: 3 },
          { name: '已截止', id: 4 },
          { name: '评审完成', id: 5 },
        ],
      },
      // 列表数据
      tableData: [],
      total: 0,
      parame: {
        status: '', // 评审流程状态（1.企业待自评 2.专家待分配 3.专家评审中 4.已截止 5.已完成）
        keyWords: '',
        page: 1,
        limit: 10,
      },
    };
  },
  watch: {},
  created() {
    this.getQuestionList();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取题库列表
    getQuestionList() {
      this.$axios.post('api/selfAssessment/selfAssessmentList', this.parame).then((res) => {
        if (res.data.code == 200) {
          const { currPage, list, pageSize, totalCount, totalPage } = res.data.page;
          this.total = totalCount;
          this.tableData = list || [];
          this.loading = false;
        }
      });
    },
    handleTabs(item) {
      this.parame.page = 1;
      this.parame.status = item.id;
      this.loading = true;
      this.getQuestionList();
    },
    // 列表-分页-变更当前页
    handleCurrentChange(val) {
      this.parame.page = val;
      this.loading = true;
      this.getQuestionList();
    },
    rowClick(item) {
      //  ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][item.status - 1]
      switch (item.status) {
        case 1: // 前往自评 / 编辑
          this.$router.push({
            path: '/initiaSelf',
            query: { id: item.id, selfId: item.selfId, status: item.status },
          });
          break;
        case 2: // 前往自评 / 编辑
          this.$router.push({
            path: '/initiaSelf',
            query: { id: item.id, selfId: item.selfId, status: item.status },
          });
          break;
        // case 2: // 查看评审报告
        //   if (item.selfUsableNumber > 0 || item.selfUsableNumber == null) {
        //     window.open(`${this.report}/report.html?selfId=${item.selfId}`, '_blank');
        //     this.common.reportsNumber(1);
        //     this.getQuestionList();
        //   } else {
        //     this.$message({
        //       message: `使用次数不足，请联系管理员！`,
        //       type: 'error',
        //       offset: 80,
        //     });
        //   }

        //   break;
        // case 3: // 查看证书
        //   this.$router.push({
        //     path: '/initiaSelf',
        //     query: { id: item.id, selfId: item.selfId, isEdit: true },
        //   });
        //   break;

        default:
          // 详情
          this.$router.push({
            path: '/selfDeil',
            query: { id: item.id, selfId: item.selfId },
          });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  margin: 15px 0;
  font-size: 14px;
  .tabsItem {
    margin-right: 10px;
    padding-bottom: 6px;
    cursor: pointer;
  }
  .activr {
    color: #1784fc;
    position: relative;
    bottom: 0;
    left: 0;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
      border-bottom: 2px solid #1784fc;
    }
  }
}
.listIpone {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid #ebecf1;
  background: #fbfdff;
  padding: 15px;
  .listIBox {
    margin-bottom: 20px;
  }
  .listIponeItem {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    // cursor: pointer;
    .left {
      .tiles {
        color: #4f5d77;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        .tiltBox {
          width: 6px;
          height: 6px;
          margin-right: 8px;
          display: inline-block;
        }
        .tileOrruge {
          background: #f68e6d;
        }
        .tileRed {
          background: #df5151;
        }
        .tileBlue {
          background: #499bde;
        }
        .tileGreen {
          background: #5b9f7b;
        }
      }
      .time {
        color: rgba(79, 93, 119, 0.6);
        line-height: 25px;
        span {
          color: #4f5d77;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01px;
        }
      }
      .box {
        width: 76px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        border-radius: 18px;
        font-size: 12px;
        margin-top: 4px;
      }
      .DayBox {
        border-radius: 18px;
        background: rgba(79, 93, 119, 0.16);
        color: rgba(79, 93, 119, 0.7);
      }
      .YearBox {
        border-radius: 18px;
        background: rgba(62, 123, 250, 0.16);
        color: rgba(62, 123, 250, 0.7);
      }
    }
    .right {
      margin-left: auto;
    }
  }
  .rowList {
    color: rgba(79, 93, 119, 0.6);
    font-size: 14px;
    line-height: 25px;
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
  #selfAssessIndex {
    .fitPc {
      display: block;
    }
    .fitIpone {
      display: none;
    }
  }
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  #selfAssessIndex {
    .fitPc {
      display: none;
    }
    .fitIpone {
      display: block;
    }
  }
}
</style>
